import type Player from 'video.js/dist/types/player';
import { getClientFeedUrl } from '~/services/request/index.ts';
import { requestJsonData } from '~/utils/request-json-data';

const DEFAULT_OVERLAY_DURATION = 30;

function playNextPlugin(
  this: Player,
  {
    playNext,
    playNextFeedUrl,
    setIsRunningPlayNext,
    setPlayNextFeed,
    setDuration,
    setCurrentPosition,
    isPostroll,
    playNextOverlayDuration,
  }: {
    playNext: () => void;
    playNextFeedUrl: string;
    isRunningPlayNext: any;
    setIsRunningPlayNext: any;
    setPlayNextFeed: any;
    setDuration: any;
    setCurrentPosition: any;
    isPostroll: boolean;
    playNextOverlayDuration: number;
  }
) {
  if (!playNextFeedUrl) return;

  const fetchPlayNextFeed = async () => {
    if (!playNextFeedUrl) return;

    const clientFeedUrl: string = getClientFeedUrl(playNextFeedUrl);

    const playNextFeed = await requestJsonData({
      url: clientFeedUrl,
      sessionStorageKey: `play-next-feed-${playNextFeedUrl}`,
    });

    setPlayNextFeed(playNextFeed);
  };

  const showPlayNextOverlay = () => {
    const duration = this.duration() || 0;
    const currentPosition = this.currentTime();

    setDuration(duration);
    setCurrentPosition(currentPosition || 0);

    const totalDuration = isPostroll
      ? 0
      : playNextOverlayDuration || DEFAULT_OVERLAY_DURATION; // TODO: get trigger time from plugin?

    const triggerTime = Math.abs(duration - totalDuration) - 1;

    if (!currentPosition || !triggerTime) {
      return;
    }

    if (currentPosition <= triggerTime) {
      setIsRunningPlayNext(false);
    }

    if (currentPosition > triggerTime) {
      setIsRunningPlayNext(true);
    }
  };

  this.on('timeupdate', showPlayNextOverlay);
  this.on('loadedmetadata', fetchPlayNextFeed);
  this.on('ended', playNext);
}

export default playNextPlugin;
